import { ChainId, CurrencyAmount, JSBI, Token, TokenAmount, WETH } from '@cronosdex/sdk'
import { useMemo } from 'react'
import {  AI_EXPERIMENTS, AI_LABS, ALIENCRO_NFT, ALIENFT, ALIEN_APOCALYPSE, APES_UTOPIA, ARMYJACKALS, ARMY_100K_TOKEN_NFT, BABY_CROGES_NFT, BABY_PHENIX, BAD_BILLY_GOATS, BAD_MEERKAT, BAD_MEERKAT_DEGEN, BAD_TREEHOUSE, BBELITE, BB_TREASURY_COIN, BLUMIES, BOBA_NFTEA, BOB_ADVENTURES, BRAINDEAD_MONKEYS, BUSHIF, BUSHIM, BUSY_BEARS, CAPONEBEAR, CAT_WIF_GAT, CHEFZ, CMB, COLONEL_TENDIE, CORGICLUB, CRAZY_CROSSBREEDS, CROARMY_DIAMONDHAND, CROARMY_JARHEADS, CROFAM_LADIES_VIP, CROFLIPS_NFT, CROHOGS, CROKINGNFT, CROMELEONS, CRONOGODDESSES, CRONOGODS, CRONOSRAGDOLL, CRONOSVERSE_NFT, CRONOS_BOSSES, CRONOS_BOT_SOCIETY, CRONOS_BULLS_AND_BEARS, CRONOS_CHIBIS, CRONOS_FOX_ELITE, CRONOS_GOATS, CRONOS_TOWERS, CRONOS_WOMEN, CRONOS_Y00TS, CROODLE_APE_V2, CROPET_NFT, CROSSBREEDS, CROUGARS, CROUGARX, CROVILIANS, CROWBOYS, CRO_HAMSTER, CRO_OF_THRONES, CRO_PUNK, CRO_SUCCUBUS, CRXILLION, CRYPTOCHAD, CYBORG_BROTHERHOOD, DAOLIST_PASS_3D, DEGENZ_SKULLS, DR_DAO_X_MUTANT, GANGVERSE_SOCIAL_CLUB, GHOST_OG, GOBLIN_CRO_PET, GREENSTIX_OG_CANDLE, GREEN_CARD, ICYCRO_NFT, ICY_NFT, ICY_VALKYRIES, ICY_VIKING_TREASURE, KARDIA, LA_BRIGADE_DE_CUISINE, LOOTERS, MAFIA, MAFIA_SAFE_HOUSE, MARIESCYBORGS, METAVERSEPIXELS, NEW_CRONOS_BULLS_AND_BEARS, NOBUDDIES_GEN2, OXLUCKLESS_V1, OXLUCKLESS_V1_5, OXLUCKLESS_V2, OXLUCKLESS_V2_2, PIXEL_CITY, REBEL_PUNKS, RECKLESS_ROBOTS, ROBOTMEERKAT, SCARECRO, SHINY_CRO_PEPE, SMART_MARS, SPICY_CROPEPE, SQUID_CROC_NFT, STRANGE_CAMEL_SOCIETY, TEENAGE_PHENIX, THE_SPORTS_NFT, TRAPPAZOIDS, TRAPPED_CROCOW, TRIPPY_TREASURE_CHEST, ULTIMATE_X_MUTANTS, WICKED_AZZ_PAWNZ, ZOMBABIES_NFT } from '../../constants/collections'
import { BABY_CROGE, BOBA, BOO, BPHENIX, BURNCRO, BUSHI, CORGI, CPBR, CROARMY, CROHC, CROKING, CRONOSCHAD, CRONOSVERSE, CRONOS_BOSS, CRX, C_TENDIES, DAOLAB, GAT, GOAT, GREENSTIX_V2, GRNSTX_V2, ICY, LOOTNETWORK, METAPX, PEPE, REYE, SCRGE, STEAK, THNDR, TREASURE, UNI, USDC, XARMY, XCRX } from '../../constants/'

import { NFT_STAKING_INTERFACE } from '../../constants/abis/nftStaking'
import { useActiveWeb3React } from '../../hooks'
import { NEVER_RELOAD, useMultipleContractSingleData, useSingleCallResult } from '../multicall/hooks'
import { tryParseAmount } from '../swap/hooks'
import { AI_EXPERIMENTS_INFO, AI_LABS_INFO, ALIENCRONFT_INFO, ALIENFT_INFO, ALIEN_APOCALYPSE_INFO, APES_UTOPIA_INFO, ARMYJACKALS_INFO, ARMY_100K_TOKEN_NFT_INFO, BABY_CROGES_INFO, BABY_PHENIX_INFO, BAD_BILLY_GOATS_INFO, BAD_MEERKAT_DEGEN_INFO, BAD_MEERKAT_INFO, BAD_TREEHOUSE_INFO, BBELITE_INFO, BB_TREASURY_COINS_INFO, BLUMIES_INFO, BOBA_NFTEA_INFO, BOB_ADVENTURES_INFO, BRAINDEAD_MONKEYS_INFO, BUSHIF_INFO, BUSHIM_INFO, BUSY_BEARS_INFO, CAPONEBEAR_INFO, CAT_WIF_GAT_INFO, CHEFZ_INFO, CMB_INFO, COLONEL_TENDIE_INFO, CORGI_CLUB_INFO, CRAZY_CROSSBREEDS_INFO, CROARMY_DIAMONDHAND_INFO, CROARMY_JARHEADS_INFO, CROFAM_LADIES_VIP_INFO, CROFLIPS_INFO, CROHOGS_INFO, CROKING_NFT_INFO, CROMELEONS_INFO, CRONOGODDESSES_INFO, CRONOGODS_INFO, CRONOSVERSE_INFO, CRONOS_BOSSES_INFO, CRONOS_BOT_SOCIETY_INFO, CRONOS_BULLS_AND_BEARS_INFO, CRONOS_CHIBIS_INFO, CRONOS_FOX_ELITE_INFO, CRONOS_GOATS_INFO, CRONOS_RAGDOLLS_INFO, CRONOS_TOWERS_INFO, CRONOS_WOMEN_INFO, CRONOS_Y00TS_INFO, CROODLE_APE_V2_INFIO, CROPET_INFO, CROSSBREEDS_INFO, CROUGARS_INFO, CROUGARX_INFO, CROVILIANS_INFO, CROWBOYS_INFO, CRO_HAMSTER_INFO, CRO_OF_THRONES_INFO, CRO_PUNKS_INFO, CRO_SUCCUBUS_INFO, CRXILLION_INFO, CRYPTOCHAD_INFO, CYBORG_BROTHERHOOD_INFO, DAOLIST_PASS_3D_INFO, DEGENZ_SKULL_INFO, DR_DAO_X_MUTANT_INFO, GANGVERSE_SOCIAL_CLUB_INFO, GHOST_OG_INFO, GOBLIN_CRO_PET_INFO, GREENSTIX_OG_CANDLE_INFO, GREEN_CARD_INFO, ICYCRO_NFT_INFO, ICY_NFT_INFO, ICY_VALKYRIES_INFO, ICY_VIKING_TREASURE_INFO, KARDIA_INFO, LA_BRIGADE_DE_CUISINE_INFO, LOOTERS_INFO, MAFIA_INFO, MAFIA_SAFE_HOUSE_INFO, MARIESCYBORGS_INFO, METAPX_INFO, NEW_CRONOS_BULLS_AND_BEARS_INFO, NOBUDDIES_GEN2_INFO, OXLUCKLESS_V1_5_INFO, OXLUCKLESS_V1_INFO, OXLUCKLESS_V2_2_INFO, OXLUCKLESS_V2_INFO, PIXEL_CITY_INFO, ProjectInfo, REBEL_PUNKS_INFO, RECKLESS_ROBOTS_INFO, ROBOTMEERKAT_INFO, SCARECRO_INFO, SHINY_CRO_PEPE_INFO, SMART_MARS_INFO, SPICY_CROPEPE_INFO, SQUID_CROC_INFO, STRANGE_CAMEL_SOCIETY_INFO, TEENAGE_PHENIX_INFO, THE_SPORTS_NFT_INFO, TRAPPAZOIDS_INFO, TRAPPED_CROCOW_INFO, TRIPPY_TREASURE_INFO, ULTIMATE_X_MUTANTS_INFO, WICKED_AZZ_PAWNZ_INFO, ZOMBABIES_INFO } from './projects'
import { useNFTStakingContract } from '../../hooks/useContract'

export const STAKING_GENESIS = 1633636800
export const UINTMAX = "115792089237316195423570985008687907853269984665640564039457584007913129639935"

export const REWARDS_DURATION_DAYS = 28


export enum NFT_STAKE_TYPES {
  LEGACY,
  RENEWABLE
}

export enum NFT_POOL_STATUS_TYPES {
  FINISHED,
  HALTED,
  LIVE,
  UPCOMING
}

interface INTERACTION_INFO {
  payable: boolean,
  depositFee: number | undefined,
  withdrawFee: number | undefined,
  claimFee: number | undefined
}

const REWARDS = [

  ////////////////////////////
  ///// ROUND 2 REWARDS /////
  //////////////////////////
  {
    collection: CRXILLION,
    projectInfo: CRXILLION_INFO,
    stakingRewardAddress: '0x14E9dD5abB076142480059c51A56bfC05E0D56ab',
    rewardToken: CRX,
    interactionInfo: { payable: false,  depositFee: undefined, withdrawFee:undefined, claimFee:undefined },
    batch: false,
    round: 2,
    type: NFT_STAKE_TYPES.LEGACY
  },
  ////////////////////////////
  ///// ROUND 3 REWARDS /////
  //////////////////////////
  {
    collection: CRXILLION,
    projectInfo: CRXILLION_INFO,
    stakingRewardAddress: '0x8376de182AfBdA28B772be8D1103A89D4d8fF40A',
    rewardToken: CRX,
    interactionInfo: { payable: false,  depositFee: undefined, withdrawFee:undefined, claimFee:undefined },
    batch: true,
    round: 3,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: CROUGARS,
    projectInfo: CROUGARS_INFO,
    stakingRewardAddress: '0x493FA56FFF6902Dd17f922bADeD56F999b3Fc20C',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 3,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: CMB,
    projectInfo: CMB_INFO,
    stakingRewardAddress: '0xF38b3782E48Cb0657696eBA606cd941F63f69Ba3',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 3,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: METAVERSEPIXELS,
    projectInfo: METAPX_INFO,
    stakingRewardAddress: '0x59Cd1834975A1749D0F8b3f6A0d5ceC158714353',
    rewardToken: METAPX,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 3,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: CRONOGODS,
    projectInfo: CRONOGODS_INFO,
    stakingRewardAddress: '0x0A77583d2141ED12744AF744f18b9a0398258212',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 3,
    type: NFT_STAKE_TYPES.LEGACY
  },

  
   ////////////////////////////
  ///// ROUND 4 REWARDS /////
  //////////////////////////
  {
    collection: CRXILLION,
    projectInfo: CRXILLION_INFO,
    stakingRewardAddress: '0xF40Cd9C29171BACC3894DF4438621F29369D5CC9',
    rewardToken: CRX,
    interactionInfo: { payable: false,  depositFee: undefined, withdrawFee:undefined, claimFee:undefined },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: ALIENFT,
    projectInfo: ALIENFT_INFO,
    stakingRewardAddress: '0xFa6aE2A16fcBc4DeC1873ee388C0555a421B7023',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: CROMELEONS,
    projectInfo: CROMELEONS_INFO,
    stakingRewardAddress: '0x250561f50D3fA2E2D3D060b8819bBFDAFFc7C92E',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: CROUGARS,
    projectInfo: CROUGARS_INFO,
    stakingRewardAddress: '0x027AE0759cF1FADfDf04A5e7bef018A1AF9f26E1',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: LOOTERS,
    projectInfo: LOOTERS_INFO,
    stakingRewardAddress: '0x6d3A0bF49705DCBa151D2Af1b0Aa17AFaeb22cFB',
    rewardToken:  LOOTNETWORK,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: RECKLESS_ROBOTS,
    projectInfo: RECKLESS_ROBOTS_INFO,
    stakingRewardAddress: '0xCcdDf33CE734706e3E031Be70f123E5E151BFF01',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: CRONOGODDESSES,
    projectInfo: CRONOGODDESSES_INFO,
    stakingRewardAddress: '0x25bed310B6d747AE84CB710d195845ddD4F17aB3',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: CROKINGNFT,
    projectInfo: CROKING_NFT_INFO,
    stakingRewardAddress: '0x04273eeb70e9A5c36E8d3E03234F7c7517B44577',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: CROKINGNFT,
    projectInfo: CROKING_NFT_INFO,
    stakingRewardAddress: '0x5Ca0604F0570c4C03311f424F723d9CfEA61903f',
    rewardToken: CROKING,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: BOBA_NFTEA,
    projectInfo: BOBA_NFTEA_INFO,
    stakingRewardAddress: '0x836c3175B6BA98AEE66a65cE1a933CafeBBA1cF8',
    rewardToken: BOBA,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },
  {
    collection: METAVERSEPIXELS,
    projectInfo: METAPX_INFO,
    stakingRewardAddress: '0x14A5A090dcE690675D2ccc372E23cE2a4d9A81EC',
    rewardToken: METAPX,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 4,
    type: NFT_STAKE_TYPES.LEGACY
  },

  ////////////////////////////
  ///// ROUND 5 REWARDS /////
  //////////////////////////
  {
    collection: CRXILLION,
    projectInfo: CRXILLION_INFO,
    stakingRewardAddress: '0xa51e49d3d61BaA416a40119368B191820b264688',
    rewardToken: CRX,
    interactionInfo: { payable: false,  depositFee: undefined, withdrawFee:undefined, claimFee:undefined },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROVILIANS,
    projectInfo: CROVILIANS_INFO,
    stakingRewardAddress: '0x8b9300baba4450eC1C242E33884C054c5F62c5dD',
    rewardToken: CRONOSVERSE,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOSVERSE_NFT,
    projectInfo: CRONOSVERSE_INFO,
    stakingRewardAddress: '0xAC8403502ac1f6886582683608a3eb55a0316b87',
    rewardToken: CRONOSVERSE,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CHEFZ,
    projectInfo: CHEFZ_INFO,
    stakingRewardAddress: '0xf829D772DBd33F7Aed62D9eE0D30870C424b2729',
    rewardToken: STEAK,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BLUMIES,
    projectInfo: BLUMIES_INFO,
    stakingRewardAddress: '0xB04d1936b12734e1c30CbC5e6DA1C0F96C9F8000',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ROBOTMEERKAT,
    projectInfo: ROBOTMEERKAT_INFO,
    stakingRewardAddress: '0xE6Efa4663FE7BB2f420E24Cdf14197DDa83CDde0',
    rewardToken: XCRX,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ICYCRO_NFT,
    projectInfo: ICYCRO_NFT_INFO,
    stakingRewardAddress: '0x6132C7ac7FD80F8756272ef1D50C9f3152257739',
    rewardToken:  ICY,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ICY_NFT,
    projectInfo: ICY_NFT_INFO,
    stakingRewardAddress: '0x772012B1652001bA624c1ff01363f80FbD60D1A2',
    rewardToken: ICY,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ICY_VIKING_TREASURE,
    projectInfo: ICY_VIKING_TREASURE_INFO,
    stakingRewardAddress: '0x42FFC4A7c5eF5375b027E4c1568f5c8A7573d7A9',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROHOGS,
    projectInfo: CROHOGS_INFO,
    stakingRewardAddress: '0xFbB6C7a2C7Ee8C85fF3b91dF99a5Eae2c51E2b5f',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ALIENCRO_NFT,
    projectInfo: ALIENCRONFT_INFO,
    stakingRewardAddress: '0x262311888aeA4931098Ac5BEb27b39e5c75669E7',
    rewardToken: CRX,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROARMY_JARHEADS,
    projectInfo: CROARMY_JARHEADS_INFO,
    stakingRewardAddress: '0x36718d8Ff47b209B6d4e301036cC5C17c709B4FB',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROARMY_DIAMONDHAND,
    projectInfo: CROARMY_DIAMONDHAND_INFO,
    stakingRewardAddress: '0xe172CB16D37619320B8c652a64C2C29c58239421',
    rewardToken: CROARMY,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ARMYJACKALS,
    projectInfo: ARMYJACKALS_INFO,
    stakingRewardAddress: '0xf1c0e861f6B30718d1F3313eEfec4f7625a9C818',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ARMY_100K_TOKEN_NFT,
    projectInfo: ARMY_100K_TOKEN_NFT_INFO,
    stakingRewardAddress: '0x356FB8eC277BfF05762377c012fD34c67454F510',
    rewardToken: XARMY,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ALIEN_APOCALYPSE,
    projectInfo: ALIEN_APOCALYPSE_INFO,
    stakingRewardAddress: '0xC960350503fE01425a718E8E8ec6a88149Bb32D8',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_WOMEN,
    projectInfo: CRONOS_WOMEN_INFO,
    stakingRewardAddress: '0xE78639Ee2751e131BBfe54A51E067Ea11F9916a4',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: LA_BRIGADE_DE_CUISINE,
    projectInfo: LA_BRIGADE_DE_CUISINE_INFO,
    stakingRewardAddress: '0x10E74e27302a2EFcAC158Ac4Dd33B5e1C72F8A1a',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRO_SUCCUBUS,
    projectInfo: CRO_SUCCUBUS_INFO,
    stakingRewardAddress: '0x0B9e2c20a00358769dc7983a2e2Cc9359c3Fab21',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: WICKED_AZZ_PAWNZ,
    projectInfo: WICKED_AZZ_PAWNZ_INFO,
    stakingRewardAddress: '0xCB3a4A7c5E69680eEa9a0db1C7DFE631C1c7aa21',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: REBEL_PUNKS,
    projectInfo: REBEL_PUNKS_INFO,
    stakingRewardAddress: '0x5846c07F6cFc7DE1F1b9E9040c7b7cFA7042Fd89',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRO_OF_THRONES,
    projectInfo: CRO_OF_THRONES_INFO,
    stakingRewardAddress: '0xeEe59E5A68E9fb8568490fBd60694E65b216D0B0',
    rewardToken: USDC,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BOB_ADVENTURES,
    projectInfo: BOB_ADVENTURES_INFO,
    stakingRewardAddress: '0x949Ed30ae17D9A0F32a506Bbd4EDd785A2435Db0',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: TEENAGE_PHENIX,
    projectInfo: TEENAGE_PHENIX_INFO,
    stakingRewardAddress: '0x9446d040efc39f1A912Fe950A16d4302D520A44e',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_Y00TS,
    projectInfo: CRONOS_Y00TS_INFO,
    stakingRewardAddress: '0xAfDa81C4A1d226663ba6Fa39D96eb52B9E15b392',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BAD_TREEHOUSE,
    projectInfo: BAD_TREEHOUSE_INFO,
    stakingRewardAddress: '0xc6E2Ed849C51db1D156408F761944b0257457294',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROSSBREEDS,
    projectInfo: CROSSBREEDS_INFO,
    stakingRewardAddress: '0x01F3716e602b8e63574C01b60A8C02a5496029Bb',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CAT_WIF_GAT,
    projectInfo: CAT_WIF_GAT_INFO,
    stakingRewardAddress: '0x6D1917777fA15B30E90537c74A6e87d0bdf49A8d',
    rewardToken: GAT,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROSSBREEDS,
    projectInfo: CROSSBREEDS_INFO,
    stakingRewardAddress: '0x9dBD2264BcbB27400f57C122676978f0542D1829',
    rewardToken: GOAT,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRAZY_CROSSBREEDS,
    projectInfo: CRAZY_CROSSBREEDS_INFO,
    stakingRewardAddress: '0x6eE2b89F7DAA71b64433227521f071Eb63A84f4B',
    rewardToken: GOAT,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BAD_BILLY_GOATS,
    projectInfo: BAD_BILLY_GOATS_INFO,
    stakingRewardAddress: '0x307Ca70C595f8fDB25a58c80A68346D75606442B',
    rewardToken: GOAT,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: TRAPPED_CROCOW,
    projectInfo: TRAPPED_CROCOW_INFO,
    stakingRewardAddress: '0x410406b1b4A81AB135B716D08E7e6E6182c3D888',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BAD_MEERKAT,
    projectInfo: BAD_MEERKAT_INFO,
    stakingRewardAddress: '0x6fD3CcB35aA5a3Dd55B4Ab76b5aF45906F16aC21',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BAD_MEERKAT_DEGEN,
    projectInfo: BAD_MEERKAT_DEGEN_INFO,
    stakingRewardAddress: '0x3BDEf8c173491763462e90Dc8A686028887B1f34',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: MAFIA,
    projectInfo: MAFIA_INFO,
    stakingRewardAddress: '0x4CbA9AB4779417D546D0FabB7A2CF95630C55164',
    rewardToken: THNDR,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: MAFIA_SAFE_HOUSE,
    projectInfo: MAFIA_SAFE_HOUSE_INFO,
    stakingRewardAddress: '0x4C1ed87287F145C57Df109e1071eEe06Be540D02',
    rewardToken: STEAK,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: LA_BRIGADE_DE_CUISINE,
    projectInfo: LA_BRIGADE_DE_CUISINE_INFO,
    stakingRewardAddress: '0x107B691513379400637d32D1C5385FA146c626FD',
    rewardToken: REYE,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CHEFZ,
    projectInfo: CHEFZ_INFO,
    stakingRewardAddress: '0x08fff88CB9FcAdc7cf861475ce38469BDC002a51',
    rewardToken: REYE,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRAZY_CROSSBREEDS,
    projectInfo: CRAZY_CROSSBREEDS_INFO,
    stakingRewardAddress: '0xf6207547B025B00420A280a7C5CC8eD7BF6a6b94',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROFAM_LADIES_VIP,
    projectInfo: CROFAM_LADIES_VIP_INFO,
    stakingRewardAddress: '0x857D414F36DAdE566dA4253fCfaC1006277AD1d2',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: GHOST_OG,
    projectInfo: GHOST_OG_INFO,
    stakingRewardAddress: '0xfeB53d1ccc7406D748fD19ebcd40DaDb3206cf22',
    rewardToken: BOO,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRO_HAMSTER,
    projectInfo: CRO_HAMSTER_INFO,
    stakingRewardAddress: '0xA749fc66cc725824b25178f680894dCd13978384',
    rewardToken: CROHC,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: GREEN_CARD,
    projectInfo: GREEN_CARD_INFO,
    stakingRewardAddress: '0x602652987F5E3b949E6E935d0288ED350475d6f3',
    rewardToken: GRNSTX_V2,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: COLONEL_TENDIE,
    projectInfo: COLONEL_TENDIE_INFO,
    stakingRewardAddress: '0x57BB196372f27cdBc349c81f94593585fa60372F',
    rewardToken: C_TENDIES,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: TRAPPAZOIDS,
    projectInfo: TRAPPAZOIDS_INFO,
    stakingRewardAddress: '0xf3fdFeB1A0d44Aa885946309E995009cBa350Da7',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: APES_UTOPIA,
    projectInfo: APES_UTOPIA_INFO,
    stakingRewardAddress: '0x4147F88971663135e699Fe08B8bD4FB25B506F0c',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_BOSSES,
    projectInfo: CRONOS_BOSSES_INFO,
    stakingRewardAddress: '0x8DB175D566F3b4203F62f70c7B95159953C10fE7',
    rewardToken: CRONOS_BOSS,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROWBOYS,
    projectInfo: CROWBOYS_INFO,
    stakingRewardAddress: '0x6135450Ad406072a3c9484E52748B4b9BEa527C0',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BB_TREASURY_COIN,
    projectInfo: BB_TREASURY_COINS_INFO,
    stakingRewardAddress: '0x180e2183A10D4d9c593AC0A937cE1aA547897118',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BABY_PHENIX,
    projectInfo: BABY_PHENIX_INFO,
    stakingRewardAddress: '0x19ddB946DF2a3D15e1Ef80552F1c65A82bdfF45d',
    rewardToken: BPHENIX,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROUGARX,
    projectInfo: CROUGARX_INFO,
    stakingRewardAddress: '0xdCD9A802ac63bDb126509BA6Bb4d902411D84cb9',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: SQUID_CROC_NFT,
    projectInfo: SQUID_CROC_INFO,
    stakingRewardAddress: '0x27F1F0858b7a09E1C978221BfC9C689bd64021aC',
    rewardToken: SCRGE,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: LOOTERS,
    projectInfo: LOOTERS_INFO,
    stakingRewardAddress: '0xA35AAA41BF9A698066E8C654b730c8f184A3c60f',
    rewardToken:  TREASURE,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: LOOTERS,
    projectInfo: LOOTERS_INFO,
    stakingRewardAddress: '0xF16a6360C3AD1C7b92E269e4a1a6d3578FF7E63a',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROPET_NFT,
    projectInfo: CROPET_INFO,
    stakingRewardAddress: '0x968A9bFFBF72241A78C0f580503e78f83A9223Ae',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: GOBLIN_CRO_PET,
    projectInfo: GOBLIN_CRO_PET_INFO,
    stakingRewardAddress: '0x0F70EF0Ade1423a3065e2DF80Bd07a49C1345eC6',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_CHIBIS,
    projectInfo: CRONOS_CHIBIS_INFO,
    stakingRewardAddress: '0x591Ca3Ac887678a1eC83874BCF2396D004126f31',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: TRIPPY_TREASURE_CHEST,
    projectInfo: TRIPPY_TREASURE_INFO,
    stakingRewardAddress: '0x0a01587563C52ec9943480CFEEeA04c359E13Ed3',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOGODS,
    projectInfo: CRONOGODS_INFO,
    stakingRewardAddress: '0x9eaF2180b8AD5d3133f170FAb5ce895126E438FA',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BUSY_BEARS,
    projectInfo: BUSY_BEARS_INFO,
    stakingRewardAddress: '0xEAcC3b5C988ad8aFCdACe907e44B5CFDC1577086',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CYBORG_BROTHERHOOD,
    projectInfo: CYBORG_BROTHERHOOD_INFO,
    stakingRewardAddress: '0xab2f8aB02A7Ce5fc13288A324302D001de63b837',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: MARIESCYBORGS,
    projectInfo: MARIESCYBORGS_INFO,
    stakingRewardAddress: '0x17F7F3D4592468461422f5E14A53677fBf067d60',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BUSHIM,
    projectInfo: BUSHIM_INFO,
    stakingRewardAddress: '0x96fE094E562d65016EaF2baA7da4C6d4dCFF4666',
    rewardToken: BUSHI,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BUSHIF,
    projectInfo: BUSHIF_INFO,
    stakingRewardAddress: '0x617a5dD08FB5819f884BAB11Db7326689E8F962d',
    rewardToken: CRX,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BUSHIF,
    projectInfo: BUSHIF_INFO,
    stakingRewardAddress: '0x54eE47562450FEeE24bA8235D432577Ba1508549',
    rewardToken: BUSHI,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: LOOTERS,
    projectInfo: LOOTERS_INFO,
    stakingRewardAddress: '0x905FBb603960ae73c5276312174cDdff08016A3c',
    rewardToken:  LOOTNETWORK,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BBELITE,
    projectInfo: BBELITE_INFO,
    stakingRewardAddress: '0x871cfFFd139d0202943125E4C8f39735979f3F5c',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: KARDIA,
    projectInfo: KARDIA_INFO,
    stakingRewardAddress: '0x49e93D833d40fFB91DDD867258B0c81f4FE90D7a',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BRAINDEAD_MONKEYS,
    projectInfo: BRAINDEAD_MONKEYS_INFO,
    stakingRewardAddress: '0xdECA23Fc93E02e0213d1CC80256bDA0e5DcE28af',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: NOBUDDIES_GEN2,
    projectInfo: NOBUDDIES_GEN2_INFO,
    stakingRewardAddress: '0x69BEce03b3ac491c329661af98B8A7161F782a5D',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: SMART_MARS,
    projectInfo: SMART_MARS_INFO,
    stakingRewardAddress: '0xD490fB50c439e0EC4A2F3DE9ce269aBC2Da06b9b',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BABY_CROGES_NFT,
    projectInfo: BABY_CROGES_INFO,
    stakingRewardAddress: '0xDF0aa5025AfC1439f0cd8E2c31a25F44C2AE5903',
    rewardToken:  BABY_CROGE,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: RECKLESS_ROBOTS,
    projectInfo: RECKLESS_ROBOTS_INFO,
    stakingRewardAddress: '0xC762C3c6d035012Bb61FF1b21c7eb989319A9ed9',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ICY_VALKYRIES,
    projectInfo: ICY_VALKYRIES_INFO,
    stakingRewardAddress: '0x3A04C60FEA2f612D6566C14c9c0eA61Afb2D3d93',
    rewardToken:  ICY,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },

  {
    collection: CRONOS_BOT_SOCIETY,
    projectInfo: CRONOS_BOT_SOCIETY_INFO,
    stakingRewardAddress: '0xc798B11A215Ffdc955E3b5Af528A5D49650e4cDA',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ZOMBABIES_NFT,
    projectInfo: ZOMBABIES_INFO,
    stakingRewardAddress: '0x0f0F57DdfBc5EF6360abDBF009d773e4287fD7Da',
    rewardToken:  WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROMELEONS,
    projectInfo: CROMELEONS_INFO,
    stakingRewardAddress: '0x9e699CEeeD6058f7401a6bD30eb8805Eb40dC0C4',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRO_PUNK,
    projectInfo: CRO_PUNKS_INFO,
    stakingRewardAddress: '0x4CcEb1BEe012c60e262987617BD6DC25709b9CAf',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ALIENFT,
    projectInfo: ALIENFT_INFO,
    stakingRewardAddress: '0x4DF2947013D68BbDF1914815DB510d1eaf7b8e4e',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: PIXEL_CITY,
    projectInfo: PIXEL_CITY_INFO,
    stakingRewardAddress: '0x694DfE86CD2BcA9b1910C2EDE6beb7Cb6274eAF1',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_TOWERS,
    projectInfo: CRONOS_TOWERS_INFO,
    stakingRewardAddress: '0x2dbc4c94b85F109965CBE365fd5519bfaEabD947',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: OXLUCKLESS_V2_2,
    projectInfo: OXLUCKLESS_V2_2_INFO,
    stakingRewardAddress: '0x1153c9A64AD1b609029C8ae79fBab628455E4034',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: STRANGE_CAMEL_SOCIETY,
    projectInfo: STRANGE_CAMEL_SOCIETY_INFO,
    stakingRewardAddress: '0x7FC742eb15d8A044c3718da8AB7dffC4e1D6B3Ab',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: OXLUCKLESS_V2,
    projectInfo: OXLUCKLESS_V2_INFO,
    stakingRewardAddress: '0xAED04e11EBed26DAA258F79bdb2898235726aC64',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: OXLUCKLESS_V1_5,
    projectInfo: OXLUCKLESS_V1_5_INFO,
    stakingRewardAddress: '0x88D1770C6dB9637033a2040117b2A90C165c6A81',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: OXLUCKLESS_V1,
    projectInfo: OXLUCKLESS_V1_INFO,
    stakingRewardAddress: '0x6A0951453cC82aC82A712323C01dE287172881fD',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: DR_DAO_X_MUTANT,
    projectInfo: DR_DAO_X_MUTANT_INFO,
    stakingRewardAddress: '0xc370a2a4b34F21477A56BDc2878E01D3Dbb22F41',
    rewardToken: DAOLAB,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: AI_LABS,
    projectInfo: AI_LABS_INFO,
    stakingRewardAddress: '0x24bcbe57e4f61Efbc6494DC5d4442A9443Ce64a5',
    rewardToken: DAOLAB,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: AI_EXPERIMENTS,
    projectInfo: AI_EXPERIMENTS_INFO,
    stakingRewardAddress: '0x05a82E57A871Fd8a26585C02f5E1E81E355d3aB6',
    rewardToken: DAOLAB,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: ULTIMATE_X_MUTANTS,
    projectInfo: ULTIMATE_X_MUTANTS_INFO,
    stakingRewardAddress: '0x5f989edAFe0D8486aB987a93cB3F9CAD4B0FB0e0',
    rewardToken: DAOLAB,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: DAOLIST_PASS_3D,
    projectInfo: DAOLIST_PASS_3D_INFO,
    stakingRewardAddress: '0x3fb984458Eb18F0d6A3A28cf7a986508F281D2D7',
    rewardToken: DAOLAB,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_BULLS_AND_BEARS,
    projectInfo: CRONOS_BULLS_AND_BEARS_INFO,
    stakingRewardAddress: '0xC7EfFF86c373332A51FEAE21585C6E624FA8C299',
    rewardToken: BURNCRO,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: NEW_CRONOS_BULLS_AND_BEARS,
    projectInfo: NEW_CRONOS_BULLS_AND_BEARS_INFO,
    stakingRewardAddress: '0xC6Ee74B1Dc27087d1Fbe1eEc0464bBc7166717bd',
    rewardToken: BURNCRO,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: SPICY_CROPEPE,
    projectInfo: SPICY_CROPEPE_INFO,
    stakingRewardAddress: '0x7aC76FB0dC97f82981b966fc536555c974bE6911',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: SHINY_CRO_PEPE,
    projectInfo: SHINY_CRO_PEPE_INFO,
    stakingRewardAddress: '0xB01c0D5Cb17D44f32BBcB895d5215a3d692c61f8',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_GOATS,
    projectInfo: CRONOS_GOATS_INFO,
    stakingRewardAddress: '0x675c53609B8feF09EdeDb8e421FdA9c5Ce3643E0',
    rewardToken: GOAT,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: DEGENZ_SKULLS,
    projectInfo: DEGENZ_SKULL_INFO,
    stakingRewardAddress: '0x3f15B6e433551C186B6da98224d97075AEd22Ca5',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: GANGVERSE_SOCIAL_CLUB,
    projectInfo: GANGVERSE_SOCIAL_CLUB_INFO,
    stakingRewardAddress: '0x72644734b37686cf58FDdd038fdd17390Fd738E3',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: GREENSTIX_OG_CANDLE,
    projectInfo: GREENSTIX_OG_CANDLE_INFO,
    stakingRewardAddress: '0xB710291d305a289Ad8759611501Ea43F8D423AD8',
    rewardToken: GREENSTIX_V2,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROODLE_APE_V2,
    projectInfo: CROODLE_APE_V2_INFIO,
    stakingRewardAddress: '0x76928663B0369a128b2e2496ed89C12b9694aF8a',
    rewardToken: PEPE,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROUGARS,
    projectInfo: CROUGARS_INFO,
    stakingRewardAddress: '0xEcC7b52D1b081dd58b1B2757bb657055323C7a03',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_BULLS_AND_BEARS,
    projectInfo: CRONOS_BULLS_AND_BEARS_INFO,
    stakingRewardAddress: '0xed3490C996B6229373d550DF260d3c22Fc039426',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOS_FOX_ELITE,
    projectInfo: CRONOS_FOX_ELITE_INFO,
    stakingRewardAddress: '0x1E3CBBECa8Bfc5D4a216540E1F8906892602fe3b',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: THE_SPORTS_NFT,
    projectInfo: THE_SPORTS_NFT_INFO,
    stakingRewardAddress: '0xc4e46ee17E1d2291BF54ca2ca30eAc5e01a1E623',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CROFLIPS_NFT,
    projectInfo: CROFLIPS_INFO,
    stakingRewardAddress: '0xF87674FC8803756F0Fa6402a3Bff24E7c9058417',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRONOSRAGDOLL,
    projectInfo: CRONOS_RAGDOLLS_INFO,
    stakingRewardAddress: '0xA094bfa396956112320f40A480cD192BE33abb94',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: SCARECRO,
    projectInfo: SCARECRO_INFO,
    stakingRewardAddress: '0x47fF3C3f8a1DdB49A21e92c1d981ef4D348144f5',
    rewardToken: WETH[ChainId.CRONOSMAINNET],
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CORGICLUB,
    projectInfo: CORGI_CLUB_INFO,
    stakingRewardAddress: '0x25AC51ABC845298Aa7A121a0730af1733B7F4D8a',
    rewardToken: CORGI,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: BOBA_NFTEA,
    projectInfo: BOBA_NFTEA_INFO,
    stakingRewardAddress: '0x0429A1F4465dc3d25d8b43f4a91E80a66dea1B69',
    rewardToken: BOBA,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CRYPTOCHAD,
    projectInfo: CRYPTOCHAD_INFO,
    stakingRewardAddress: '0x970F010972EBad2B93AA620F0332B396ad5d7964',
    rewardToken: CRONOSCHAD,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: METAVERSEPIXELS,
    projectInfo: METAPX_INFO,
    stakingRewardAddress: '0x653A09Dc52945c2d9c00A7D7652Fad6ffe4F20fe',
    rewardToken: METAPX,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  {
    collection: CAPONEBEAR,
    projectInfo: CAPONEBEAR_INFO,
    stakingRewardAddress: '0x0a9BCF1fd5575e94F05B1c77C6061e24f9145f1F',
    rewardToken: CPBR,
    interactionInfo: { payable: true, depositFee:1, withdrawFee:1, claimFee:1 },
    batch: true,
    round: 5,
    type: NFT_STAKE_TYPES.RENEWABLE
  },
  

  /////////////////////////
  ///// TEST REWARDS /////
  ///////////////////////
  // {
  //   collection: CROUGARS,
  //   mintPage: "https://crougar.com/",
  //   mintPriceinWCROAmount:  225,
  //   mintPriceinCustomAmount: undefined,
  //   stakingRewardAddress: '0xCc1AE5c74295B3246cddb3C6B1f496Cc57d25EE1',
  //   rewardToken: TCN,
  //   interactionInfo: { payable: true, depositFee:0, withdrawFee:0, claimFee:0 },
  //   round: 2
  // },
  // {
  //   collection: TESTCRXILLION,
  //   mintPage: "https://nft.crodex.app/crxillion/index.html",
  //   mintPriceinWCROAmount:  400,
  //   mintPriceinCustomAmount: { tokenObj: CRX, amount: 2},
  //   stakingRewardAddress: '0x4c1Ea4d6FFAaf67aF4A11439b479Ef1DE2319ef3',
  //   rewardToken: TCN,
  //   interactionInfo: { payable: true,  depositFee: 0.1, withdrawFee:0.1, claimFee:0.1 },
  //   batch: true,
  //   round: 3
  // },
]

// TODO add staking rewards addresses here
export const STAKING_REWARDS_INFO: {
  [chainId in ChainId]?: {
    collection: Token
    projectInfo: ProjectInfo
    stakingRewardAddress: string
    rewardToken: Token
    interactionInfo: INTERACTION_INFO
    batch: boolean
    round: number
    type: NFT_STAKE_TYPES
  }[]
} = {
  [ChainId.CRONOSMAINNET]: REWARDS
}



export interface NFTStakeInfo {
  // Project info
  projectInfo: ProjectInfo
  // the address of the reward contract
  stakingRewardAddress: string
  // the tokens involved in this pair
  collection: Token
  // the reward tokens
  rewardToken: Token
  // the interaction info
  interactionInfo: INTERACTION_INFO
  // batch interaction 
  batch: boolean
  // round info
  round: number
  // rewards istribution address
  rewardsDistribution: string
  // type
  type: NFT_STAKE_TYPES
  // pool status
  poolStatus: NFT_POOL_STATUS_TYPES
  // the amount of token currently staked, or undefined if no account
  stakedAmount: TokenAmount
  // the amount of reward token earned by the active account, or undefined if no account
  earnedAmount: TokenAmount
  // the total amount of token staked in the contract
  totalStakedAmount: TokenAmount
  // the amount of token distributed per second to all LPs, constant
  totalRewardRate: TokenAmount
  // the current amount of token distributed to the active account per second.
  // equivalent to percent of total supply * reward rate
  rewardRate: TokenAmount
  // when the period ends
  periodFinish: Date | undefined
  // calculates a hypothetical amount of token distributed to the active account per second.
  getHypotheticalRewardRate: (
    stakedAmount: TokenAmount,
    totalStakedAmount: TokenAmount,
    totalRewardRate: TokenAmount
  ) => TokenAmount
}

// gets the staking info from the network for the active chain id
export function useNFTStakeInfo(rewardToFilterBy?: string | null): NFTStakeInfo[] {
  const { chainId, account } = useActiveWeb3React()
  const info = useMemo(
    () =>
      chainId
        ? STAKING_REWARDS_INFO[chainId]?.filter(
          stakingRewardInfo =>
              (rewardToFilterBy === undefined) ? true :
              (rewardToFilterBy === stakingRewardInfo.stakingRewardAddress) // rewardToFilterBy.equals(stakingRewardInfo.token)
        ) ?? []
        : [],
    [chainId, rewardToFilterBy]
  )

  const uni = chainId ? UNI[chainId] : undefined

  const rewardsAddresses = useMemo(() => info.map(({ stakingRewardAddress }) => stakingRewardAddress), [info])

  const accountArg = useMemo(() => [account ?? undefined], [account])

  // get all the info from the staking rewards contracts
  const balances = useMultipleContractSingleData(rewardsAddresses, NFT_STAKING_INTERFACE, 'balanceOf', accountArg)
  const earnedAmounts = useMultipleContractSingleData(rewardsAddresses, NFT_STAKING_INTERFACE, 'earned', accountArg)
  const totalSupplies = useMultipleContractSingleData(rewardsAddresses, NFT_STAKING_INTERFACE, 'totalSupply')
  
  const rewardsDistribution = useMultipleContractSingleData(rewardsAddresses, NFT_STAKING_INTERFACE, 'rewardsDistribution')

  // tokens per second, constants
  const rewardRates = useMultipleContractSingleData(
    rewardsAddresses,
    NFT_STAKING_INTERFACE,
    'rewardRate',
    undefined,
    NEVER_RELOAD
  )
  const periodFinishes = useMultipleContractSingleData(
    rewardsAddresses,
    NFT_STAKING_INTERFACE,
    'periodFinish',
    undefined,
    NEVER_RELOAD
  )

  return useMemo(() => {
    if (!chainId || !uni) return []

    return rewardsAddresses.reduce<NFTStakeInfo[]>((memo, rewardsAddress, index) => {
      // these two are dependent on account
      const balanceState = balances[index]
      const earnedAmountState = earnedAmounts[index]

      // these get fetched regardless of account
      const totalSupplyState = totalSupplies[index]
      const rewardRateState = rewardRates[index]
      const periodFinishState = periodFinishes[index]
      const rewardsDistributionState = rewardsDistribution[index]

      if (
        // these may be undefined if not logged in
        !balanceState?.loading &&
        !earnedAmountState?.loading &&
        // always need these
        totalSupplyState &&
        !totalSupplyState.loading &&
        rewardRateState &&
        !rewardRateState.loading &&
        periodFinishState &&
        !periodFinishState.loading &&
        rewardsDistributionState &&
        !rewardsDistributionState.loading
      ) {
        if (
          balanceState?.error ||
          earnedAmountState?.error ||
          totalSupplyState?.error ||
          rewardRateState?.error ||
          periodFinishState?.error
        ) {
          console.error('Failed to load staking rewards info')
          return memo
        }

        // get the LP token
        const token = info[index].collection

        // check for account, if no account set to 0
        // let userDepositedNFT = []
        // const userDepositLen = userDepositsState ? userDepositsState?.result?.[0].length : 0
        // for ( var idx = 0; idx < userDepositLen; idx++ ){
        //   const tokenIDstr = userDepositsState?.result?.[0][idx]?.toString()
        //   if ( tokenIDstr !== UINTMAX)
        //     userDepositedNFT.push((parseInt(tokenIDstr)))
        // }

        const stakedAmount = balanceState?.result ? new TokenAmount(token, JSBI.BigInt(balanceState?.result?.[0] ?? 0)) : new TokenAmount(token, JSBI.BigInt(balanceState?.result?.[0] ?? 0))
        const totalStakedAmount = new TokenAmount(token, JSBI.BigInt(totalSupplyState.result?.[0]))
        const totalRewardRate = new TokenAmount(info[index].rewardToken, JSBI.BigInt(rewardRateState.result?.[0]))
        const rewardsDistribution = rewardsDistributionState?.result?.[0]

        const getHypotheticalRewardRate = (
          stakedAmount: TokenAmount,
          totalStakedAmount: TokenAmount,
          totalRewardRate: TokenAmount
        ): TokenAmount => {
          return new TokenAmount(
            info[index].rewardToken,
            JSBI.greaterThan(totalStakedAmount.raw, JSBI.BigInt(0))
              ? JSBI.divide(JSBI.multiply(totalRewardRate.raw, stakedAmount.raw), totalStakedAmount.raw)
              : JSBI.BigInt(0)
          )
        }

        const individualRewardRate = getHypotheticalRewardRate(stakedAmount, totalStakedAmount, totalRewardRate)

        const periodFinishMs = periodFinishState.result?.[0]?.mul(1000)?.toNumber()
        const isRewardEnded = new Date().getTime() > periodFinishMs ? true : false

        let poolStatus;
        if ( info[index].type === NFT_STAKE_TYPES.LEGACY )
          poolStatus = NFT_POOL_STATUS_TYPES.FINISHED
        else if ( isRewardEnded )
          poolStatus = NFT_POOL_STATUS_TYPES.HALTED
        else
          poolStatus = NFT_POOL_STATUS_TYPES.LIVE

        
        memo.push({
          stakingRewardAddress: rewardsAddress,
          projectInfo: info[index].projectInfo,
          collection: info[index].collection,
          rewardToken: info[index].rewardToken,
          interactionInfo: info[index].interactionInfo,
          batch: info[index].batch,
          round: info[index].round,
          rewardsDistribution: rewardsDistribution,
          type: info[index].type,
          poolStatus: poolStatus,
          periodFinish: periodFinishMs > 0 ? new Date(periodFinishMs) : undefined,
          earnedAmount: new TokenAmount(info[index].rewardToken, JSBI.BigInt(earnedAmountState?.result?.[0] ?? 0)),
          rewardRate: individualRewardRate,
          totalRewardRate: totalRewardRate,
          stakedAmount: stakedAmount,
          totalStakedAmount: totalStakedAmount,
          getHypotheticalRewardRate
        })
      }
      return memo
    }, [])
  }, [info, balances, chainId, earnedAmounts, periodFinishes, rewardRates, rewardsAddresses, totalSupplies, uni])
}


// gets the staking info from the network for the active chain id
export function useNFTUserDepositsInfo(contractAddress: string): number[] {
  const { chainId, account } = useActiveWeb3React()

  const nftStakingContract = useNFTStakingContract(contractAddress)
  const userDeposits = useSingleCallResult(nftStakingContract, 'userDeposits', [account ?? undefined])
  

  return useMemo(() => {

    let memo :number[] = []


    if (!chainId || !account) return memo
    else {
        if (
            !userDeposits?.loading
        ){
            if (
                userDeposits?.error
            ) {
                console.error('Failed to load NFT Staking User Deposits info')
                return memo
            }

            let userDepositedNFT = []
            const userDepositLen = userDeposits ? userDeposits?.result?.[0].length : 0
            for ( var idx = 0; idx < userDepositLen; idx++ ){
              const tokenIDstr = userDeposits?.result?.[0][idx]?.toString()
              if ( tokenIDstr !== UINTMAX)
                userDepositedNFT.push((parseInt(tokenIDstr)))
            }
            memo = userDepositedNFT
            return memo 
        }
        return memo
    }   
}, [account, chainId, userDeposits])
}



export function useTotalUniEarned(): TokenAmount | undefined {
  const { chainId } = useActiveWeb3React()
  const uni = chainId ? UNI[chainId] : undefined
  const stakingInfos = useNFTStakeInfo()

  return useMemo(() => {
    if (!uni) return undefined
    return (
      stakingInfos?.reduce(
        (accumulator, stakingInfo) => accumulator.add(stakingInfo.earnedAmount),
        new TokenAmount(uni, '0')
      ) ?? new TokenAmount(uni, '0')
    )
  }, [stakingInfos, uni])
}

// based on typed value
export function useDerivedStakeInfo(
  typedValue: string,
  stakingToken: Token,
  userLiquidityUnstaked: TokenAmount | undefined
): {
  parsedAmount?: CurrencyAmount
  error?: string
} {
  const { account } = useActiveWeb3React()

  const parsedInput: CurrencyAmount | undefined = tryParseAmount(typedValue, stakingToken)

  const parsedAmount =
    parsedInput && userLiquidityUnstaked && JSBI.lessThanOrEqual(parsedInput.raw, userLiquidityUnstaked.raw)
      ? parsedInput
      : undefined

  let error: string | undefined
  if (!account) {
    error = 'Connect Wallet'
  }
  if (!parsedAmount) {
    error = error ?? 'Enter an amount'
  }

  return {
    parsedAmount,
    error
  }
}

// based on typed value
export function useDerivedUnstakeInfo(
  typedValue: string,
  stakingAmount: TokenAmount
): {
  parsedAmount?: CurrencyAmount
  error?: string
} {
  const { account } = useActiveWeb3React()

  const parsedInput: CurrencyAmount | undefined = tryParseAmount(typedValue, stakingAmount.token)

  const parsedAmount = parsedInput && JSBI.lessThanOrEqual(parsedInput.raw, stakingAmount.raw) ? parsedInput : undefined

  let error: string | undefined
  if (!account) {
    error = 'Connect Wallet'
  }
  if (!parsedAmount) {
    error = error ?? 'Enter an amount'
  }

  return {
    parsedAmount,
    error
  }
}
